import API from 'services/API';

export default function saveFeedback(data) {
  return API.request({
    method: 'POST',
    url: `/notification/feedback/save`,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    data,
  });
}
